import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'
import { emojiConfigQueryOptions, type Emoji } from '#features/emoji-selection'
import type { EmojiConfig } from '#shared/model/emoji-config'

let cachedActionEmojis: Emoji[] | null = null

function getActionEmojis(emojiConfig: EmojiConfig, emojiChars: string[]) {
  if (cachedActionEmojis) return cachedActionEmojis

  const allEmojis = emojiConfig.flatMap(category => category.content.flatMap(subcategory => subcategory.content))
  const actionEmojis = emojiChars
    .map(emojiChar => allEmojis.find(emoji => emoji.char === emojiChar))
    .filter(Boolean) as Emoji[]

  cachedActionEmojis = actionEmojis
  return actionEmojis
}

export function useReactionActionEmojis() {
  const emojiChars = ['👍', '👎', '🔥', '👀', '❤', '🤡']

  const emojiConfigQuery = useQuery(emojiConfigQueryOptions)
  const emojiConfig = computed(() => emojiConfigQuery.data.value)

  const actionEmojis = computed(() => (emojiConfig.value ? getActionEmojis(emojiConfig.value, emojiChars) : []))

  return actionEmojis
}
